// extracted by mini-css-extract-plugin
module.exports = {"textColumns":"textColumns-module--textColumns--3SoUA"};